<template>
  <div class="flex flex-col flex-1 overflow-y-auto w-full gap-2">
    <div class="grid grid-cols-3 gap-4">
      <info-card
        :title="$t('home.incoming_calls_count')"
        :subtitle="$t('home.call')"
        :count="incomingCount"
        icon="mdi-phone-outline"
      ></info-card>
      <info-card
        class="bg-orange-red"
        :title="$t('home.outgoing_calls')"
        :subtitle="$t('home.call')"
        :count="outgoingCount"
        icon="mdi-phone-outline"
      ></info-card>
      <agent-status-select />
      <div
        class="flex justify-between align-center h-28 bg-grey-blue p-5 rounded-xl text-xl"
      >
        <label>{{ $t("home.agent_summary.talk_time") }}</label>
        <div class="flex flex-col justify-center items-center">
          <p class="text-primary-500 text-3xl">{{ incomingDuration }}</p>
        </div>
      </div>
      <div
        class="flex justify-between align-center h-28 bg-grey-blue p-5 rounded-xl text-xl"
      >
        <label>{{ $t("home.missed_calls_count") }}</label>
        <p class="text-primary-500 text-3xl">{{ unansweredCount }}</p>
      </div>
      <div
        class="flex justify-between align-center h-28 bg-grey-blue p-5 rounded-xl text-xl"
      >
        <label>{{ $t("home.agent_summary.staff_time") }}</label>
        <div class="flex flex-col justify-center items-center">
          <p class="text-primary-500 text-3xl">{{ staffDuration }}</p>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-2 auto-rows-[600px] gap-4">
      <agent-last-calls />
      <internal-conversations-card />
      <socila-media-card v-if="hasPermisson(omniChannelPermission)" />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import InfoCard from "@/components/InfoCard.vue";
import AgentStatusSelect from "@/pages/agent/dashboard/components/AgentStatusSelect.vue";
import InternalConversationsCard from "./components/InternalConversationsCard.vue";
import AgentLastCalls from "./components/AgentLastCalls.vue";
import SocilaMediaCard from "./components/SocilaMediaCard.vue";

export default {
  name: "agentHome",
  components: {
    InfoCard,
    AgentStatusSelect,
    InternalConversationsCard,
    AgentLastCalls,
    SocilaMediaCard,
  },
  data() {
    return {
      ACRT: 15,
      missedCalls: 10,
      AHT: 30,
      chartData: null,
      chartOptions: null,

      numberText: "",
      userSkills: [],
      skillsNames: [],
      drToggle: false,
      reasonMode: false,
      crmMode: false,
      ticketMode: false,
      tabToggle: "0",
      statusWidth: 0,
      restingPeriod: 0,
      selectedSkills: [],
      restStatusInt: null,
      userPermission: [],
      currentCallTimeout: null,
      reasonsTimeout: null,
      // currentCall: { CallerID: "0123456789" },
      summaryInterval: null,
      incomingCount: 0,
      outgoingCount: 0,
      unansweredCount: 0,
      averageCallResponseTime: 0,
      staffDuration: "00:00:00",
      incomingDuration: "00:00:00",
      userType: 0,
      tabheader: [
        "Recent Calls history",
        "Calls Summary of the last 7 days",
        "skills statistics",
      ],
    };
  },
  methods: {
    GoToConversation(id) {
      this.$router.push({ name: "SocialMediaConversations", params: { id } });
    },
    setChartData() {
      const documentStyle = getComputedStyle(document.documentElement);
      const primaryColor = documentStyle.getPropertyValue("--p-primary-500");

      return {
        labels: [
          "8:00",
          "9:00",
          "10:00",
          "11:00",
          "12:00",
          "13:00",
          "14:00",
          "15:00",
        ],
        datasets: [
          {
            data: [100, 75, 50, 55, 40, 90, 70, 75],
            fill: true,
            borderColor: primaryColor,
            tension: 0.4,
            pointBackgroundColor: "#fff",
            pointBorderColor: primaryColor,
            pointRadius: 5,
            pointHoverRadius: 6,
            backgroundColor: function (context) {
              const chart = context.chart;
              const { ctx, chartArea } = chart;

              if (!chartArea) {
                return primaryColor;
              }

              const gradient = ctx.createLinearGradient(
                0,
                chartArea.top,
                0,
                chartArea.bottom
              );

              gradient.addColorStop(0, "#09951E");
              gradient.addColorStop(1, "rgba(255, 255, 255, 0.1)");

              return gradient;
            },
          },
        ],
      };
    },
    setChartOptions() {
      const documentStyle = getComputedStyle(document.documentElement);
      const textColor = documentStyle.getPropertyValue("--p-primary-900");
      const surfaceBorder = documentStyle.getPropertyValue("--p-light-grey");

      return {
        maintainAspectRatio: false,
        aspectRatio: 0.6,
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            display: false,
          },
        },
        scales: {
          x: {
            ticks: {
              color: textColor,
            },
            grid: {
              color: surfaceBorder,
            },
          },
          y: {
            min: 0,
            max: 100,
            ticks: {
              stepSize: 20,
              color: textColor,
            },
            grid: {
              color: surfaceBorder,
            },
          },
        },
      };
    },
    hasPermisson(permission) {
      return this.userPermission.includes(permission);
    },
    setReasonMode(inMode) {
      if (inMode) {
        clearTimeout(this.reasonsTimeout);
        this.reasonMode = true;
      } else {
        this.reasonsTimeout = setTimeout(() => {
          this.reasonMode = false;
        }, 5000);
      }
    },
    setInfoCreateMode(status) {
      this.crmMode = status;
    },
    setTicketCreateMode(status) {
      this.ticketMode = status;
    },
    async setSkills(sentSkillinfo) {
      let payload = {
        skills: sentSkillinfo.skills,
        workPlace: sentSkillinfo.workPlace,
        phone: sentSkillinfo.phone,
      };
      this.ShowProgressBar({ show: true, message: "Updating Skill status" });
      try {
        const resp = await this.setUserSkill(payload);
        this.ShowProgressBar({ show: false, message: "" });
        if (!resp.success) {
          this.SetMessageDialog({ show: true, message: resp.message });
        } else {
          // this.SetMessageDialog({
          //   show: true,
          //   message: resp.message,
          //   success: resp.success,
          // });
          // await this.autoLogin();
        }
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.ShowProgressBar({ show: false, message: "" });
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    async initHome() {
      this.userPermission = this.permissions;
      this.userType = this.type;
      await this.GetCallReasons();
      await this.GetACWSettings();
      if (this.hasPermisson(this.callerInfoPermission)) {
        await this.GetInitCRM();
        if (this.CRMInitInfo?.has_info_create) {
          await this.GetLocalCRMFields();
        }
        if (this.CRMInitInfo?.has_ticket_create) {
          await this.GetLocalTicketingFields();
        }
      }
      if (!this.hasPermisson(this.agentsReportsPermission)) {
        this.tabToggle = "2";
      }
      
      this.chartData = this.setChartData();
      this.chartOptions = this.setChartOptions();
    },
    getSelectedSkills() {
      if (this.skills) {
        this.selectedSkills = [];
        for (const skill of this.skills) {
          if (skill.selected) {
            this.selectedSkills.push(skill);
          }
        }
        return this.selectedSkills;
      } else {
        return [];
      }
    },
    setRestDuration() {
      if (!this.restEndtime) {
        return;
      }
      this.restingPeriod =
        (new Date(+this.restEndtime).getTime() - new Date().getTime()) / 1000;
      this.restStatusInt = setInterval(() => {
        if (this.restingPeriod > 0) {
          this.restingPeriod--;
        }
      }, 1000);
    },
    onResize() {
      this.statusWidth = window.innerWidth;
    },
    withACW(work) {
      return this.acwSettings?.after_work.includes(work) && this.inAcw;
    },
    async getSummary() {
      try {
        var resp = await this.GetAgentSummary();
        if (!resp.success) {
          return;
        } else {
          this.incomingCount = resp.summary.summaryCalls.incomingcount;
          this.outgoingCount = resp.summary.summaryCalls.outgoingCount;
          this.unansweredCount = resp.summary.unAnswered;
          this.averageCallResponseTime = resp.summary.averageCallResponseTime;
          this.staffDuration = resp.summary.staffDuration;
          this.incomingDuration = resp.summary.summaryCalls.incomingDuration;
        }
      } catch (err) {
        // let message = err.message;
        // if (err.response) {
        //   message = err.response.data.message;
        // }
        // this.SetMessageDialog({ show: true, message: message });
      }
    },
    async initSummary() {
      await this.getSummary();
      this.summaryInterval = setInterval(() => {
        this.getSummary();
      }, 15000);
      this.$store.commit("setsummaryInterval", this.summaryInterval);
    },
    ...mapActions([
      "SetMessageDialog",
      "ShowProgressBar",
      "setUserSkill",
      "GetActiveCall",
      "GetCallReasons",
      "GetACWSettings",
      "GetInitCRM",
      "GetLocalCRMFields",
      "GetLocalTicketingFields",
      "GetAgentSummary",
    ]),
    ...mapMutations(["setIncall", "setIsConnected"]),
  },
  computed: {
    ...mapGetters([
      "permissions",
      "type",
      "skills",
      "domain",
      "uname",
      "status",
      "restEndtime",
      "workPhone",
      "workPlace",
      "agentsReportsPermission",
      "queueDashboardPermission",
      "agentStatusPermission",
      "skillChoosePermission",
      "summaryStatsPermission",
      "callReasonPermission",
      "phonePermission",
      "sipPermission",
      "ticketsPermission",
      "callerInfoPermission",
      "inCall",
      "isPhoneDrawn",
      "callReasons",
      "currentCall",
      "inAcw",
      "acwSettings",
      "acwReason",
      "acwCRM",
      "acwTicketing",
      "CRMInitInfo",
      "omniChannelPermission",
    ]),
    setSkillStatusColor() {
      switch (this.status) {
        case 1:
          return "green-darken-3";
        case 2:
          return "amber-lighten-2";
        case 3:
          return "red-darken-1";
        default:
          return "red-darken-4";
      }
    },
    durationFormat() {
      var date = new Date(null);
      date.setSeconds(this.restingPeriod);
      return date.toISOString().substring(11, 19);
    },
    restClass() {
      if (this.status == 2) {
        return "bg-amber-lighten-2";
      } else {
        return "";
      }
    },
  },
  watch: {
    domain() {
      this.initHome();
    },
    status(value) {
      if (value == 2 && this.restEndtime) {
        this.setRestDuration();
      } else {
        clearInterval(this.restStatusInt);
      }
    },
    statusWidth(value) {
      console.log("My status width:::", value);
    },
  },
  created() {
    if (this.domain) {
      this.initHome();
      this.initSummary();
    }
    if (this.status == 2 && this.restEndtime) {
      this.setRestDuration();
    } else {
      clearInterval(this.restStatusInt);
    }
  },
  unmounted() {
    if (this.currentCallTimeout) {
      clearTimeout(this.currentCallTimeout);
      this.currentCallTimeout = null;
    }
    if (this.restStatusInt) {
      clearInterval(this.restStatusInt);
      this.restStatusInt = null;
    }
  },
};
</script>

<style scoped>
.p-knob {
  fill: none !important;
}
</style>
